import {
  deleteMessages,
  getAnnouncement,
  getMessages,
  oneClickRead,
  setRead,
} from "@/apis/user";
import { PAGE_SIZE } from "@/constants/config";
import { MsgItem } from "@/stores/user/useUserMsgStore";
import { useInfiniteScroll } from "ahooks";
import { Toast } from "antd-mobile";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

export const useLogic = () => {
  const navigate = useNavigate();
  const messagesListRef = useRef(null);
  const announcementsListRef = useRef(null);

  const messagesList = useInfiniteScroll<{
    list: MsgItem[];
    total: number;
  }>(
    async (d) => {
      const page = d ? Math.ceil(d.list.length / PAGE_SIZE) + 1 : 1;
      const newParams = { page, pageSize: PAGE_SIZE };
      const response = await getMessages(newParams);
      return {
        list: response.data?.list ?? [],
        total: response.data?.total ?? 0,
      };
    },
    {
      manual: true,
      target: messagesListRef,
      isNoMore: (d) => d?.total === 0 || d?.total === d?.list.length,
    }
  );

  const announcementsList = useInfiniteScroll<{
    list: MsgItem[];
    total: number;
  }>(
    async (d) => {
      const page = d ? Math.ceil(d.list.length / PAGE_SIZE) + 1 : 1;
      const newParams = { page, pageSize: PAGE_SIZE };
      const response = await getAnnouncement(newParams);
      return {
        list: response.data?.list ?? [],
        total: response.data?.total ?? 0,
      };
    },
    {
      manual: true,
      target: announcementsListRef,
      isNoMore: (d) => d?.total === 0 || d?.total === d?.list.length,
    }
  );

  const toDetail = (item: MsgItem) => {
    localStorage.setItem("MSG_CONTENT", item.content);
    navigate(`/msg_detail`);
  };

  const fetchDeleteMessage = async (selectKeys: string[]) => {
    const res = await deleteMessages({ contentId: selectKeys.join(",") });
    if (res.ok) {
      messagesList.reload();
    } else {
      Toast.show(res.msg);
    }
  };

  const fetchClickRead = async (item: MsgItem) => {
    if (item.status === "Unread") {
      const res = await setRead({ contentId: item.contentId });
      if (res.ok) {
        toDetail(item);
      } else {
        Toast.show(res.msg);
      }
    } else {
      toDetail(item);
    }
  };

  const fetchAllRead = async () => {
    const res = await oneClickRead({});
    if (res.ok) {
      messagesList.reload();
    } else {
      Toast.show(res.msg);
    }
  };

  return {
    toDetail,
    announcementsList,
    messagesList,
    messagesListRef,
    announcementsListRef,
    fetchAllRead,
    fetchClickRead,
    fetchDeleteMessage,
  };
};
